export const TMDB_IMAGE_URL = "https://image.tmdb.org/t/p/w500/";
export const TMDB_MAIN = "https://api.themoviedb.org/3";
export const API_KEY = process.env.REACT_APP_API_KEY;
export const [poster_path] = "kqjL17yufvn9OVLyXYpvtyrFfak.jpg"